/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ExportParams1,
  MossStatement,
  StatementGenerationRequest,
  StatementGenerationResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiStatementControllerV2<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-statement-controller-v-2
   * @name GenerateCustomStatement
   * @request POST:/api/v1/wallets/{walletId}/statements/generate
   */
  generateCustomStatement = (
    walletId: string,
    data: StatementGenerationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<StatementGenerationResponse, any>({
      path: `/v1/wallets/${walletId}/statements/generate`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static generateCustomStatementPath = '/v1/wallets/${walletId}/statements/generate'
  static generateCustomStatementMethod = 'POST'
  /**
   * No description
   *
   * @tags api-statement-controller-v-2
   * @name Get
   * @request GET:/api/v1/wallets/{walletId}/statements
   */
  get = (walletId: string, params: RequestParams = {}) =>
    this.http.request<MossStatement[], any>({
      path: `/v1/wallets/${walletId}/statements`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getPath = '/v1/wallets/${walletId}/statements'
  static getMethod = 'GET'
  /**
   * No description
   *
   * @tags api-statement-controller-v-2
   * @name Export
   * @request GET:/api/v1/wallets/{walletId}/statements/{id}/export
   */
  export = ({ walletId, id, ...query }: ExportParams1, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/wallets/${walletId}/statements/${id}/export`,
      method: 'GET',
      query: query,
      ...params,
    })

  static exportPath = '/v1/wallets/${walletId}/statements/${id}/export'
  static exportMethod = 'GET'
}
